<div *ngIf="showInstallButton" class="pwa-install-card d-none d-sm-block d-md-block d-lg-none">
  <div class="install-card-content">
    <i class="fas fa-mobile-alt install-icon"></i>
    <div class="install-info">
      <h4>Install Aplikasi</h4>
      <p>Dapatkan akses lebih cepat dan fitur offline</p>
    </div>
    <button (click)="installApp()" class="btn-install-card">Install</button>
  </div>
</div>

<router-outlet></router-outlet>
<app-toastr></app-toastr>
<app-modal></app-modal>
<app-modal-sign-out></app-modal-sign-out>
<app-modal-change-password></app-modal-change-password>
<app-tenant-modal></app-tenant-modal>
<app-building-modal></app-building-modal> <!--TW20251010-->
<app-modal-incomplete></app-modal-incomplete>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-atom" [fullScreen]="true">
  <p style="color: white">Loading...</p>
</ngx-spinner>